import React from 'react';
import ScheduledDaysLabel from "./ScheduledDaysLabel";

const displayScheduledDays = (scheduledDays, sameDateMultiplePractices) => {
    if (sameDateMultiplePractices && sameDateMultiplePractices.length === 0) {
        return scheduledDays;
    } else {
        return (
            <ScheduledDaysLabel
                scheduledDays={scheduledDays}
                sameDateMultiplePractices={sameDateMultiplePractices}
            />
        );
    }
}

export default displayScheduledDays;